export default __webpack_public_path__ + "static/media/ic-care-support.3a7c8b0c.svg";